import React, { useEffect } from 'react';
import { PurchaseToast } from './components/PurchaseToast';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SystemSection } from './components/SystemSection';
import { ModulesSection } from './components/ModulesSection';
import { PreviewCarousel } from './components/PreviewCarousel';
import { BonusSection } from './components/BonusSection';
import { DifferentiatorSection } from './components/DifferentiatorSection';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
interface AppProps {
  showPurchasePopup?: boolean;
}
export function App({
  showPurchasePopup = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      // Meta Pixel initialization (hardened against sandboxed previews)
      ;
      (function (f: any, b: any, e: any, v: any) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e);
        t.async = !0;
        t.src = v;
        const s = b.getElementsByTagName(e)[0];
        if (s && s.parentNode) {
          s.parentNode.insertBefore(t, s);
        } else {
          ;
          (b.head || b.documentElement).appendChild(t);
        }
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1492774178719165');
      (window as any).fbq('track', 'PageView');
    } catch (err) {
      console.warn('Meta Pixel init skipped:', err);
    }
  }, []);
  return <>
      <noscript data-id="element-0" data-mp="356rv4texg92">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=1492774178719165&ev=PageView&noscript=1" alt="" data-id="element-1" data-mp="34nbhsjeuzx5" />
      </noscript>

      <div className="min-h-screen w-full overflow-x-hidden bg-cream text-charcoal" data-id="element-2" data-mp="d2bhxfqdpvv5">
        <main data-id="element-3" data-mp="83i1pfjpjqra">
          <Hero data-id="element-4" data-mp="3gle7gc7darc0" />
          <ProblemSection data-id="element-5" data-mp="3gkv17sr2xrdt" />
          <SystemSection data-id="element-6" data-mp="3gmfsn9i3ku7g" />
          <ModulesSection data-id="element-7" data-mp="3glnz048296jt" />
          <PreviewCarousel data-id="element-8" data-mp="3bmbg1ukb8jmi" />
          <BonusSection data-id="element-9" data-mp="3bn30c98giuxh" />
          <DifferentiatorSection data-id="element-10" data-mp="3bnuudfmeokln" />
          <Offer data-id="element-11" data-mp="3bkgtycxaylgu" />
          <Guarantee data-id="element-12" data-mp="3qaxuzv60z9d7" />
          <Testimonials data-id="element-13" data-mp="3qc966g1svjec" />
          <FAQ data-id="element-14" data-mp="3qcimfbx1mc6u" />
          <FinalCTA data-id="element-15" data-mp="3qdag2h72xzuh" />
        </main>
        <Footer data-id="element-16" data-mp="3ljxu6etsc75f" />
        {showPurchasePopup && <PurchaseToast data-id="element-17" data-mp="3liwlui45lyre" />}
      </div>
    </>;
}